import React from "react";

const Tab = ({ title, onClick, isActive }) => {
  const tabActiveClasses =
    "bg-white inline-block border-l border-t border-r rounded-t py-2 px-4 text-blue-700 font-semibold";
  const tabInactiveClasses =
    "bg-gray-300 inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold";

  return (
    <li className={`mr-1 ${isActive ? "-mb-px" : ""}`}>
      <a
        onClick={e => {
          e.preventDefault();
          onClick();
        }}
        href="#"
        className={isActive ? tabActiveClasses : tabInactiveClasses}
      >
        {title}
      </a>
    </li>
  );
};

const Tabs = ({ activeTabId, setActiveTabId }) => {
  return (
    <ul className="flex border-b px-6">
      <Tab
        title="✍🏻Write"
        onClick={() => setActiveTabId("write")}
        isActive={activeTabId === "write"}
      />
      <Tab
        title="🎙Record"
        onClick={() => setActiveTabId("record")}
        isActive={activeTabId === "record"}
      />
      <Tab
        title="🚀Publish"
        onClick={() => setActiveTabId("publish")}
        isActive={activeTabId === "publish"}
      />
    </ul>
  );
};

export default Tabs;
